import LoadingSpinner from "./loading-spinner";

export default function LoadingScreen() {
    return (
        <div className="flex h-full w-full items-center justify-center py-[40vh]">
            <LoadingSpinner className="size-12 fill-primary " />
        </div>
    );
}
